const PEM_BEGIN = '-----BEGIN CERTIFICATE-----';
const PEM_END = '-----END CERTIFICATE-----';
/**
 * Reformat a single-line PEM (spaces instead of newlines) into standard multi-line PEM.
 */
export function reformatSingleLinePem(value) {
    if (!value.includes(PEM_BEGIN) || !value.includes(PEM_END)) {
        return value;
    }
    const beginIdx = value.indexOf(PEM_BEGIN);
    const afterBegin = value.slice(beginIdx + PEM_BEGIN.length);
    if (afterBegin.startsWith('\n') || afterBegin.startsWith('\r')) {
        return value;
    }
    const base64 = value
        .replace(PEM_BEGIN, '')
        .replace(PEM_END, '')
        .replace(/\s+/g, '');
    if (!base64) {
        return value;
    }
    const lines = base64.match(/.{1,64}/g) || [base64];
    return `${PEM_BEGIN}\n${lines.join('\n')}\n${PEM_END}`;
}
/**
 * Normalize pasted PEM certificate text (EK/AK registration, CSV import).
 * Strips leading/trailing whitespace and wrapping single/double quotes.
 */
export function sanitizePemCertificateInput(value) {
    let trimmed = value.trim();
    while ((trimmed.startsWith('"') && trimmed.endsWith('"')) ||
        (trimmed.startsWith("'") && trimmed.endsWith("'"))) {
        trimmed = trimmed.slice(1, -1).trim();
    }
    if (!trimmed.includes('\n') && trimmed.includes('\\n')) {
        trimmed = trimmed.replace(/\\n/g, '\n');
    }
    trimmed = trimmed.replace(/\r\n/g, '\n').replace(/\r/g, '\n').trim();
    return reformatSingleLinePem(trimmed);
}
//# sourceMappingURL=pem-utils.js.map